import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AOS from "aos";
import "./ComplianceCenter.css"
import "aos/dist/aos.css";
import {
  FiShield, FiFileText, FiLock, FiUserCheck, FiBook,
  FiArrowRight, FiCheckCircle
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const ComplianceCenter = () => {
    const navigate = useNavigate();
const location = useLocation();
const params = new URLSearchParams(location.search);
const product = params.get("product");


const complianceSections = [
  {
    id: "awareness",
    heading: "Security Awareness",
    icon: <FiShield />,
    tagline: "Stay informed and secure",
    items: [
      { title: "Cyber Security Awareness - English", path: "/file/Cyber-Security-Awareness-Tips-2024-10-24-English.pdf", type: "PDF", subtitle: "Standard Security Protocols" },
      { title: "Cyber Security Awareness - Telugu", path: "/file/Cyber-Security-Awareness-Tips-2024-10-24-Telugu.pdf", type: "PDF", subtitle: "Regional Security Guide" },
      { title: "Cyber Security Awareness - Kannada", path: "/file/Cyber-Security-Awareness-Tips-2024-10-24-Kannada.pdf", type: "PDF", subtitle: "Regional Security Guide" },
      { title: "Fraud Awareness", path: "/compliance-center/fraud-awareness", type: "Safety", subtitle: "Protecting against digital fraud" },
      { title: "Customer Security Awareness Info", path: "/compliance-center/customer-security-awareness-information", type: "Info", subtitle: "Essential security tips" },
    ],
  },
  {
    id: "legal",
    heading: "Legal & Governance",
    icon: <FiLock />,
    tagline: "Terms and Regulatory rules",
    items: [
    
      { title: "RBI Vision 2025", path: "/file/RBI-vision-2025.pdf", type: "Strategy", subtitle: "Future of digital payments" },
      { title: "Roles & Responsibilities", path: "/compliance-center/roles-responsibilities-of-npci-psb-tpap", type: "NPCI", subtitle: "NPCI, PSB & TPAP Guidelines" },
      { title: "Terms of Reference CSR Program", path: "/compliance-center/terms-of-reference-of-csr-program-tripartite-agreement", type: "Agreement", subtitle: "Tripartite Agreement details" },
    ],
  },
  {
    id: "protection",
    heading: "Customer Protection",
    icon: <FiUserCheck />,
    tagline: "Privacy and Redressal",
    items: [
      { title: "Customer Protection Policy", path: "/compliance-center/customer-protection-policy", type: "Policy", subtitle: "Limiting liability of customers" },
      { title: "Customer Grievance Policy", path: "/compliance-center/customer-grievance-policy", type: "Support", subtitle: "Escalation matrix and resolution" },
      { title: "Data Privacy Policy", path: "/compliance-center/data-privacy-policy", type: "Privacy", subtitle: "Data collection and usage" },
      { title: "Dispute Redressal Mechanism", path: "/compliance-center/dispute-redressal-mechanism", type: "Support", subtitle: "Handling payment disputes" },
    ],
  },
  
{
  id: "product-rules",
  heading:
    product === "paymentgateway"
      ? "Payment Aggregation Services"
      : product === "bbps"
      ? "BBPS Business"
      : product === "onboarding"
      ? "Onboarding Stack"
      : "PPI Busines",

  icon: <FiBook />,

  tagline: "Compliance & Terms",

  items:
    product === "paymentgateway"
      ? [
          {
            title: "Payment Gateway Services Terms of Service",
            path: "/compliance-center/papg-termsof-service",
            type: "Legal",
            subtitle: "Merchant acquiring guidelines"
          },
          {
            title: "Payment Gateway Services Privacy Policy",
            path: "/compliance-center/papgprivacy-policy",
            type: "Security",
            subtitle: "Gateway security compliance"
          }
        ]

      : product === "bbps"
      ? [
          {
            title: "TA BBPS Biller Agreement T & C",
            path: "/file/TA BBPS Biller Agreement T & Cs.pdf",
            type: "BBPS",
            subtitle: "Bharat Bill Payment System framework"
          }
        ]
    : product === "onboarding"
      ? [
  
          {
            title: "Aadhaar eKYC Compliance",
            path: "/compliance-center/ekyc-compliance",
            type: "UIDAI",
            subtitle: "UIDAI authentication guidelines"
          },
          {
            title: "Identity Verification Policy",
            path: "/compliance-center/identity-verification",
            type: "Policy",
            subtitle: "Customer onboarding verification rules"
          }
        ]

      : [
          {
            title: "T Wallet Terms & Conditions - English",
            path: "/file/Website T Wallet Terms & Conditions English.pdf",
            type: "Legal",
            subtitle: "Official T Wallet usage terms"
          },
          {
            title: "T Wallet Terms & Conditions - Hindi",
            path: "/file/Website T Wallet Terms & Conditions Hindi.pdf",
            type: "Legal",
            subtitle: "T Wallet terms in Hindi"
          },
          {
            title: "T Wallet Terms & Conditions - Kannada",
            path: "/file/Website T Wallet Terms & Conditions Kannada.pdf",
            type: "Legal",
            subtitle: "T Wallet terms in Kannada"
          },
              {
            title: "T Wallet Terms & Conditions - Telugu",
            path: "/file/Website T Wallet Terms & Conditions Telugu.pdf",
            type: "Legal",
            subtitle: "T Wallet terms in Telugu"
          },
          {
            title: "TA Wallet Terms & Conditions - English",
            path: "/compliance-center/ta-wallet-terms-conditions",
            type: "Legal",
            subtitle: "Official TA Wallet usage terms"
          },
          {
            title: "TA Wallet Terms & Conditions - Hindi",
            path: "/compliance-center/terms-conditions-hindi",
            type: "Legal",
            subtitle: "TA Wallet terms in Hindi"
          },
          {
            title: "TA Wallet Terms & Conditions - Kannada",
            path: "/compliance-center/terms-conditions-kannada",
            type: "Legal",
            subtitle: "TA Wallet terms in Kannada"
          },
            {
            title: "Jan Aadhaar E-Wallet Terms & Conditions - English",
            path: "/file/Website JAWS Terms & Conditions English.pdf",
            type: "Legal",
            subtitle: "Jan Aadhaar E-Wallet Terms & Conditions in English"
          },
             {
            title: "Jan Aadhaar E-Wallet Terms & Conditions - Hindi",
            path: "/file/Website JAWS Terms & Conditions Hindi.pdf",
            type: "Legal",
            subtitle: "Jan Aadhaar E-Wallet Terms & Conditions in Hindi"
          },
           
           
           { title: "TAG Wallet Terms & Conditions - English",
             path: "/file/Website TAG Wallet Terms & Conditions English.pdf", 
             type: "Legal", 
             subtitle: "TAG Wallet Terms & Conditions in English" },

          { title: "TAG Wallet Terms & Conditions in Hindi",
             path: "/file/Website TAG Wallet Terms & Conditions Hindi.pdf", 
             type: "Legal", 
             subtitle: "TAG Wallet Terms & Conditions in Hindi" },

          { title: "TAG Wallet Terms & Conditions - Kannada",
             path: "/file/Website TAG Wallet Terms & Conditions Kannda.pdf", 
             type: "Legal", 
             subtitle: "TAG Wallet Terms & Conditions in Kannada" },
          { title: "TAG Wallet Terms & Conditions - Telugu",
             path: "/file/Website TAG Wallet Terms & Conditions Telugu.pdf", 
             type: "Legal", 
             subtitle: "TAG Wallet Terms & Conditions in Telugu" },

      // { title: "PPI Rules", 
      //   path: "/compliance-center/ppi-rules",
      //    type: "Gov", 
      //    subtitle: "RBI Prepaid Payment Instrument rules" },
        ]
}
];
  useEffect(() => {
    AOS.init({ duration: 800, once: false, mirror: true });
  }, []);
  const [activeTab, setActiveTab] = useState("awareness");

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="compliance-root">
      <style>
        {`
          .compliance-root {
            background: #ffffff;
            font-family: 'Inter', sans-serif;
            color: #2d3748;
          }

          .hero-banner {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            height: 200px; 
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            border-bottom: 1px solid #edf2f7;
            padding: 0 20px;
          }
          .hero-banner h1 { font-size: 32px; font-weight: 800; color: #1a202c; margin-bottom: 8px; }
          .hero-banner p { color: #718096; font-size: 16px; max-width: 700px; }

          .main-wrapper {
            max-width: 1200px;
            margin: 40px auto 80px;
            display: grid;
            grid-template-columns: 320px 1fr;
            gap: 40px;
            padding: 0 20px;
          }

          .nav-list { display: flex; flex-direction: column; gap: 12px; }
          .nav-item {
            display: flex;
            align-items: center;
            padding: 16px 20px;
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.2s ease;
            border: 1px solid transparent;
            background: #f8fafc;
          }
          .nav-item:hover { background: #edf2f7; }
          .nav-item.active {
            background: #ffffff;
            border-color: #278329;
            box-shadow: 0 4px 12px rgba(39, 131, 41, 0.1);
          }
          .nav-icon {
            width: 36px;
            height: 36px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;
            background: #e2e8f0;
            color: #4a5568;
            transition: 0.2s;
          }
          .nav-item.active .nav-icon { background: #278329; color: white; }
          .nav-title { font-weight: 700; font-size: 15px; color: #1a202c; }
          .nav-tagline { font-size: 12px; color: #718096; }

          .details-panel { background: #ffffff; }
          .list-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px;
            border-radius: 12px;
            border: 1px solid #edf2f7;
            margin-bottom: 12px;
            text-decoration: none;
            transition: all 0.2s ease;
          }
          .list-item:hover {
            border-color: #278329;
            background: #f0fdf4;
            transform: translateY(-2px);
          }
          .item-info h4 { margin: 0; font-size: 16px; color: #1a202c; font-weight: 700; }
          .item-info span { font-size: 13px; color: #718096; }
          
          .badge {
            background: #e6fffa;
            color: #2c7a7b;
            padding: 4px 12px;
            border-radius: 6px;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
          }

          @media (max-width: 900px) {
            .main-wrapper { grid-template-columns: 1fr; }
            .nav-list { flex-direction: row; overflow-x: auto; padding-bottom: 15px; }
            .nav-item { min-width: 250px; }
          }
        `}
      </style>

   <section className="hero-banner">
<div className="hero-header">
  <button className="back-btn" onClick={() => navigate(-1)}>
   <b> <i className="bi bi-arrow-left" ></i></b>
  </button>

  <h1 className="hero-title">Compliance & Trust Center</h1>
</div>

  <p>
    Your comprehensive resource for security awareness, regulatory frameworks,
    and consumer protection policies.
  </p>
</section>

      <div className="main-wrapper">
        <aside className="nav-list">
          <p style={{ fontWeight: 800, fontSize: '11px', color: '#a0aec0', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '10px' }}>Documentation Categories</p>
          {complianceSections.map((sec) => (
            <div 
              key={sec.id}
              className={`nav-item ${activeTab === sec.id ? 'active' : ''}`}
              onClick={() => setActiveTab(sec.id)}
            >
              <div className="nav-icon">{sec.icon}</div>
              <div>
                <div className="nav-title">{sec.heading}</div>
                <div className="nav-tagline">{sec.tagline}</div>
              </div>
            </div>
          ))}
        </aside>

        <main className="details-panel">
          <AnimatePresence mode="wait">
            {complianceSections.filter(s => s.id === activeTab).map((section) => (
              <motion.div 
                key={section.id}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -15 }}
              >
                <div style={{ marginBottom: '30px', borderBottom: '2px solid #f1f5f9', paddingBottom: '15px' }}>
                  <h2 style={{ fontSize: '24px', fontWeight: 800, color: '#1a202c' }}>{section.heading}</h2>
                  <p style={{ color: '#718096' }}>{section.tagline}</p>
                </div>

                <div className="list-container">
                  {section.items.map((item, i) => (
                  <div
    key={i}
    className="list-item"
    style={{ cursor: "pointer" }}
    onClick={() => {
        if (item.type === "PDF") {
            window.open(item.path, "_blank");
        } else {
            navigate(item.path);
        }
    }}
>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '40px', height: '40px', background: '#f8fafc', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '20px', color: '#278329' }}>
                          <FiFileText size={20} />
                        </div>
                        <div className="item-info">
                          <h4>{item.title}</h4>
                          <span>{item.subtitle}</span>
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <span className="badge">{item.type}</span>
                        <FiArrowRight color="#cbd5e0" />
                      </div>
                  </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
A        </main>
      </div>

      <footer style={{ background: '#f8fafc', padding: '60px 20px', borderTop: '1px solid #edf2f7' }}>
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginBottom: '30px' }}>
              <FiCheckCircle size={32} color="#278329" />
              <FiShield size={32} color="#278329" />
              <FiLock size={32} color="#278329" />
            </div>
            <h3 style={{ fontWeight: 800, fontSize: '22px', marginBottom: '15px' }}>Committed to Regulatory Excellence</h3>
            <p style={{ color: '#718096', lineHeight: '1.7', marginBottom: '25px' }}>
              Our systems are built with <strong>UIDAI, NPCI, and CERT-IN compliance</strong>  to ensure the highest levels of data protection and operational integrity.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
          <button
  onClick={() => navigate("/contactus")}
  style={{
    background: "#278329",
    color: "white",
    border: "none",
    padding: "12px 28px",
    borderRadius: "8px",
    fontWeight: 700,
    cursor: "pointer",
  }}
>
  Contact Compliance Team
</button>

<button
  onClick={() => window.open("https://udir.transactionanalysts.com/customergrievance", "_blank")}
  style={{
    background: "transparent",
    color: "#278329",
    border: "2px solid #278329",
    padding: "10px 28px",
    borderRadius: "8px",
    fontWeight: 700,
    cursor: "pointer",
  }}
>
  Report a Grievance
</button>
            </div>
          </div>
      </footer>
    </div>
  );
};

export default ComplianceCenter;